import Taro from '@tarojs/taro';
import { isH5 } from './util';

const PAGE_WEBVIEW = '/pages/webview/index';

/**
 * 后端返回的可能是网页链接，需要在 webview 中打开
 * 也可能是小程序自身的链接，只能用 navigate/redirect 之类的打开
 * 就需要有个地方统一判断处理
 */

export function jump(options) {
  const {
    url, // 跳转链接
    title = '', // 跳转title
    payload = {}, // 跳转链接上带的参数
    method = 'navigateTo', // 跳转方法
    encode = true,
  } = options;
  const decodeUrl = decodeURIComponent(url);
  if (/^(https?:)?\/\//.test(decodeUrl)) {
    if (isH5) {
      window.location.href = url;
    } else {
      Taro[method]({
        url: urlStringify(PAGE_WEBVIEW, { decodeUrl, title }),
      });
    }

  } else if (/^\/pages\//.test(decodeUrl)) { // 内页
    // TODO H5 不支持 switchTab，暂时 back 下
    if (isH5 && method === 'switchTab') {
      Taro.navigateBack({ delta: Taro.getCurrentPages().length - 1 });
      setTimeout(() => { Taro.redirectTo({ decodeUrl }); }, 100);
      return;
    }
    const pl = {};
  for (let key in payload) {
    if(payload[key]) pl[key] = payload[key]
  }
    Taro[method]({
      url: urlStringify(decodeURIComponent(decodeUrl), pl, encode),
    });
  }
}

export function jumpSign(options) {
  console.log('sign')
  const {
    url, // 跳转链接
    payload = {}, // 跳转链接上带的参数
    method = 'navigateTo', // 跳转方法
  } = options;
  const pl = {};
  for (let key in payload) {
    if(payload[key]) pl[key] = payload[key]
  }
  if (isH5) {
    console.log('h5')
    window.location.href = `${window.location.origin}${urlStringify(url, pl)}`;
  } else {
    Taro[method]({
      url: urlStringify(url, pl),
    });
  }
}

function urlStringify(url, payload, encode = true) {
  const arr = Object.keys(payload).map(key => `${key}=${encode ? encodeURIComponent(payload[key]) : payload[key]}`);
  // 注意支付宝小程序跳转链接如果没有参数，就不要带上 ?，否则可能无法跳转
  return arr.length ? `${url}?${arr.join('&')}` : url;
}
